module.exports = __webpack_public_path__ + "img/04.9ad745b3.png";